import { useAuth0 } from '@auth0/auth0-react'
import { React,useState,useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { forgotPassword } from '../../../store/slices/users/usersThunks'
// import NewUserRegisterScreen from './NewUserRegisterScreen'
// import ResetPasswordScreen from './ResetPasswordScreen'
import '../../../styles/resetPassword.css'
const ResetPasswordScreen = () => {
    const dispatch = useDispatch();
    const { loginWithRedirect } = useAuth0();
    const [error, setErrors] = useState(false);
    const [errorText, setErrorText] = useState("Please complete the field");
    const [input, setInput] = useState({
      email: "",
    });

    const handleChange = (e) => {
      setInput({
        ...input,
        [e.target.id]: e.target.value,
      });
      console.log(input.email);
    };
  //create a function to validate if input.email content @ 
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (input.email.length > 0) {
        const result = await dispatch(forgotPassword(input.email));
        if (result?.ok) {
          setTimeout(() => {
            loginWithRedirect();
          }, 1000);
        } else {
          setErrorText("We couldn't send the reset email, please try again");
          setErrors(true);
          setTimeout(() => {
            setErrors(false);
          }, 3000);
        }
      } else {
        setErrorText("Please complete the field");
        setErrors(true);
        setTimeout(() => {
          setErrors(false);
        }, 2000);
      }
    };
    
  return (
  <>
  <div>
  <html class="body-html-containerpassword">
<head>
  <meta charset="utf-8"/>
  <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
  <title>Sign In with Auth0</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"/>
  
</head>
<body class="body-html-containerpassword">
  <div class="login-container">
  <img src="https://r2.easyimg.io/9zldqe0dm/cloudcostingcco.png" alt="" />
    <div class=" login-box">
      <div class="login-header">
      <img src="https://i.postimg.cc/yNZ7zy5j/favicon.jpg" style={{width:"75%", height: "54%"}} />
        <h3>Reset your password</h3>
        <p class="fs-5">Please enter your email, we will send a message to change your password</p>
      { error ? <span class="error-msg"> {errorText}</span> : <span></span>}
      </div>
      <div id="error-message" class="alert alert-danger"></div>
      <form class="form-floating" onsubmit="return false;" method="post">
        <div class="form-group">
          <label class="fs-4 fw-bolder" for="email">Email</label>
          <input
            maxLength={50}
            type="email"
            class={`form-control form-control-lg`}
            id="email"
            onChange={(e) =>handleChange(e)} 
            placeholder={error ? "Complete the field... ":"Enter your email"}/>
        </div>
      
        <button
          type="button"
          onClick={(e)=>{handleSubmit(e)}}
          class={error ? "btn btn-lg btn-danger btn-block rounded-3": "btn btn-lg btn-primary btn-block rounded-3"}>
           Send email 
        </button>
      </form>
    </div>
  </div> 
</body>
</html>
  </div>
  
  </>)   
}
   
  

export default ResetPasswordScreen